import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Snackbar,
  TextField,
  Typography
} from '@mui/material';
import { crm } from '../../api/crm';

// Admin Settings: CRM admins. The sales team itself (leaders, executives, lead flow,
// permissions, quotas) is managed in the Team tab.
const AdminSettings = () => {
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [createAdminOpen, setCreateAdminOpen] = useState(false);
  const [newAdmin, setNewAdmin] = useState({ number: '', email: '', password: '' });

  const handleCreateAdmin = async () => {
    if (!newAdmin.number?.trim()) {
      setSnackbar({ open: true, message: 'Number is required', severity: 'error' });
      return;
    }
    try {
      await crm('users', {
        method: 'POST',
        body: {
          number: newAdmin.number.trim(),
          email: newAdmin.email?.trim() || '',
          password: newAdmin.password?.trim() || 'temp123', // placeholder if empty
          role: 'admin'
        }
      });
      setSnackbar({ open: true, message: 'Admin created', severity: 'success' });
      setCreateAdminOpen(false);
      setNewAdmin({ number: '', email: '', password: '' });
    } catch (e) {
      setSnackbar({ open: true, message: e.message || 'Failed to create admin', severity: 'error' });
    }
  };

  return (
    <Box sx={{ p: { xs: 0, sm: 2 } }}>
      <Typography variant="h6" fontWeight={700} gutterBottom>Admin Settings</Typography>
      <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
        <Typography variant="subtitle1" fontWeight={600}>Admins</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          An admin sees every team and every lead. Team leaders, executives, lead flow and permissions are managed in the Team tab.
        </Typography>
        <Button variant="contained" onClick={() => setCreateAdminOpen(true)}>Create Admin</Button>
      </Paper>

      <Dialog open={createAdminOpen} onClose={() => setCreateAdminOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Create Admin</DialogTitle>
        <DialogContent>
          <TextField fullWidth label="Login Number" value={newAdmin.number} onChange={(e) => setNewAdmin((p) => ({ ...p, number: e.target.value.replace(/\D/g, '').slice(-10) }))} sx={{ mt: 1, mb: 2 }} inputProps={{ inputMode: 'numeric' }} />
          <TextField fullWidth label="Email" value={newAdmin.email} onChange={(e) => setNewAdmin((p) => ({ ...p, email: e.target.value }))} sx={{ mb: 2 }} />
          <TextField fullWidth label="Password (optional)" type="password" value={newAdmin.password} onChange={(e) => setNewAdmin((p) => ({ ...p, password: e.target.value }))} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCreateAdminOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleCreateAdmin}>Create</Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar((s) => ({ ...s, open: false }))}>
        <Alert severity={snackbar.severity} onClose={() => setSnackbar((s) => ({ ...s, open: false }))}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default AdminSettings;
